import { TextStyle } from '@client/style/TextStyles';
import { Colors } from '@client/style/Variables';
import styled, { css } from 'styled-components';

// Text styles
export const commonTextStyle = css`
	${TextStyle.family('title')}
	${TextStyle.size('large', 'xlarge', 'laptop')}
	line-height: 1.3em;
`;

export const boldTextStyle = css`
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
`;

export const heading1TextStyle = css`
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
	${TextStyle.size('p2', 'h6', 'laptop')}
	line-height: 1.1em;
`;

export const heading2TextStyle = css`
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
	${TextStyle.size('p3', 'p2', 'laptop')}
	line-height: 1.1em;
`;

export const heading3TextStyle = css`
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
	${TextStyle.size('p6', 'p3', 'laptop')}
	line-height: 1em;
`;

// Components
export const CommonTitle = styled.h2`
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
	${TextStyle.size('p3', 'h3', 'laptop')}
	text-align: center;
	margin: 0px;
	hyphens: auto;
	overflow-wrap: anywhere;
`;

export const CommonSubTitle = styled.div`
	${TextStyle.family('title')}
	${TextStyle.size('p3')}
	text-align: center;
	padding: 0px;
	color: ${Colors.lightText};
	margin: 0px;
`;

export const CommonText = styled.div`
	${commonTextStyle}
	text-align: center;
	margin: 0px;
	margin-top: 10px;
`;

export const CommonBoldText = styled.div`
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
	${TextStyle.size('p5')}
	text-align: center;
	color: ${Colors.lightText};
`;
